import { BsCheck } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import { FiExternalLink } from "react-icons/fi";
import {
  Container,
  TitleContainer,
  Title,
  CardHeader,
  Cards,
  LabelInfo,
  ViewButton,
  ContentContainer,
  AreaFilter,
  ElementTag,
  ContentTag,
  StatusTag,
  IconsDiv,
  DeleteIcon,
} from "../styles";

import { useEffect, useState } from "react";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import { useIntl } from "react-intl";
import { notification, Divider, Empty, Spin, Tag, Badge } from "antd";
import { useSelector } from "react-redux";
import {
  deleteCredentialTemplate,
  getAllCredentialsByEvent,
} from "../../../service/manage.access";
import { useHistory, useParams } from "react-router-dom";
import { useToast } from "../../../hooks/toast";
import ConfirmationModal from "../../../components/ConfirmationModal";
import ControlledSelect from "../../../components/ControlledInputs/select";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { getActiveSortedEvents } from "../../../service/event.service";

const AdminManegeCredentialTemplate = () => {
  const { chosenEvent, chosenEventName, chosenCredential } = useParams();
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const [templates, setTemplates] = useState([]);
  const history = useHistory();
  const { addToast } = useToast();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedIdToDelete, setSelectedIdToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [eventValue, setEventValue] = useState();
  const [eventLabel, setEventLabel] = useState();
  const [listEvents, setListEvents] = useState([]);

  const eventSchema = z.object({
    selectedEvent: z.object(
      {
        value: z.number(),
        label: z.string(),
      },
      {
        required_error: intl.formatMessage({ id: "required_field" }),
      }
    ),
  });

  const form = useForm({
    resolver: zodResolver(eventSchema),
    mode: "onChange",
    defaultValues: {
      selectedEvent: null,
    },
  });

  const { control, formState, handleSubmit, reset, setValue } = form;

  useEffect(() => {
    getEvents();

    if (chosenEvent) {
      const numberChosenEvent = Number(chosenEvent);
      setEventValue(numberChosenEvent);
      setEventLabel(chosenEventName);
      getCredentialsByEvent(numberChosenEvent);
    }
  }, []);

  useEffect(() => {
    if (eventValue && listEvents.length > 0) {
      const selectedEventOption = listEvents.find(
        (option) => option.idNumber === eventValue
      );

      if (selectedEventOption) {
        setValue("selectedEvent", selectedEventOption);
      }
    }
  }, [eventValue, listEvents, setValue]);

  const getCredentialsByEvent = async (selectedEvent) => {
    const response = await getAllCredentialsByEvent({
      token,
      eventId: selectedEvent,
    });

    if (response && response.data) {
      setTemplates(response.data.credentials);
    }
  };

  const handleDeleteCredentialTemplate = async (id) => {
    try {
      await deleteCredentialTemplate({
        token,
        eventId: eventValue,
        modelId: id,
      });

      addToast({
        type: "success",
        title: intl.formatMessage({ id: "success" }),
        description: intl.formatMessage({
          id: "success.deleted_template",
        }),
      });

      await getCredentialsByEvent(eventValue);
    } catch (error) {
      addToast({
        type: "error",
        title: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "error.deleting_template",
        }),
      });
    } finally {
      setModalIsOpen(false);
    }
  };

  const getEvents = async () => {
    try {
      const events = await getActiveSortedEvents({ token });

      setListEvents(events);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "error" }),
      });
    }
  };

  return (
    <AnimatedMainContainer
      breadcrumb={intl.formatMessage({ id: "breadcumb.manage_access" })}
    >
      <Spin spinning={isLoading}>
        <Container>
          <TitleContainer>
            <Title>{intl.formatMessage({ id: "credential_templates" })}</Title>
          </TitleContainer>

          <AreaFilter>
            <ControlledSelect
              required
              control={control}
              formState={formState}
              name="selectedEvent"
              label="event"
              placeholder={intl.formatMessage({
                id: "manage_access_selected_event",
              })}
              options={listEvents}
              onChange={(chosenEvent) => {
                setEventValue(chosenEvent.idNumber);
                setEventLabel(chosenEvent.label);
                getCredentialsByEvent(chosenEvent.idNumber);
              }}
            />
          </AreaFilter>

          {templates.length === 0 && <Empty />}
          <ContentContainer>
            {templates.map((item, index) => (
              <Cards key={index}>
                <ElementTag>
                  <Tag
                    color="#F1F2F4"
                    style={{
                      borderRadius: "8px",
                      padding: "5px 10px",
                      maxHeight: "32px",
                      minHeight: "32px",
                    }}
                  >
                    <ContentTag>
                      {item.hasModel ? (
                        <BsCheck size={20} color="#22C55E" />
                      ) : (
                        <IoClose size={20} color="#616468" />
                      )}
                      <StatusTag
                        colorText={item.hasModel ? "#22C55E" : "#616468"}
                      >
                        {item.hasModel
                          ? intl.formatMessage({ id: "configured_template" })
                          : intl.formatMessage({
                              id: "not_configured_template",
                            })}
                      </StatusTag>
                    </ContentTag>
                  </Tag>

                  {item.hasModel && (
                    <IconsDiv>
                      <DeleteIcon
                        onClick={() => {
                          setSelectedIdToDelete(item.model.id);
                          setModalIsOpen(true);
                        }}
                        size={24}
                      />
                    </IconsDiv>
                  )}
                </ElementTag>

                <CardHeader>
                  <div>
                    <LabelInfo>
                      <strong>{intl.formatMessage({ id: "event" })}: </strong>
                      {eventLabel || ""}
                    </LabelInfo>
                    <LabelInfo>
                      <strong>
                        {" "}
                        {intl.formatMessage({ id: "credential" })}:
                      </strong>{" "}
                      {intl.formatMessage({ id: item.credentialType })}{" "}
                    </LabelInfo>
                  </div>
                </CardHeader>

                <Divider />

                <ViewButton
                  cursor={!eventValue ? "not-allowed" : "pointer"}
                  disabled={!eventValue ? true : false}
                  onClick={() =>
                    !item.hasModel
                      ? history.push(
                          `/admin/credential-template-form/${eventValue}/${eventLabel}/${item.credentialType}`
                        )
                      : history.push(
                          `/admin/credential-template-form/${eventValue}/${eventLabel}/${item.credentialType}/${item.model.id}`
                        )
                  }
                >
                  <FiExternalLink size={20} />
                  {!item.hasModel
                    ? intl.formatMessage({ id: "create_credential_template" })
                    : intl.formatMessage({
                        id: "visualization_credential_template",
                      })}
                </ViewButton>
              </Cards>
            ))}
          </ContentContainer>
        </Container>
      </Spin>

      <ConfirmationModal
        setIsOpen={setModalIsOpen}
        modalIsOpen={modalIsOpen}
        confirmationFunction={() =>
          handleDeleteCredentialTemplate(selectedIdToDelete)
        }
        description={intl.formatMessage({
          id: "delete_template_confirmation",
        })}
        confirmationText={intl.formatMessage({ id: "yes" })}
        cancelText={intl.formatMessage({ id: "no" })}
      />
    </AnimatedMainContainer>
  );
};

export default AdminManegeCredentialTemplate;
